import React from "react";
import {createPortal} from "react-dom";
import {useUiContext} from "../../context/uiContext";
import {useDetailsSheetContext} from "../../context/detailsSheetContext";
import ShopListWrapperMobile from "../ShopListWrapperMobile";
import SheetSection from "../SheetSection";

const MobileShopListContainer = () => {

    const mount = document.getElementById('js--mobile-shop-list-container');
    const [{isMobile}] = useUiContext();
    const [{shopsQueryState, gtmClassName}] = useDetailsSheetContext();

    if (!mount || !isMobile) return null;

    return createPortal(
            <SheetSection label="Magasins partenaires proches">
                <ShopListWrapperMobile shopsQueryState={shopsQueryState} gtmClassName={gtmClassName}/>
            </SheetSection>
    , mount);
}

export default MobileShopListContainer;